import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "context/AuthContext";
import { SelectedDeviceProvider } from "context/SelectedDeviceContext";
import "./index.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <BrowserRouter>
    <AuthProvider>
      <SelectedDeviceProvider>
        <App />
      </SelectedDeviceProvider>
    </AuthProvider>
  </BrowserRouter>
);
